import { render } from "./DuelsFilterCount.vue?vue&type=template&id=802931b0&scoped=true"
import script from "./DuelsFilterCount.vue?vue&type=script&lang=js"
export * from "./DuelsFilterCount.vue?vue&type=script&lang=js"

import "./DuelsFilterCount.vue?vue&type=style&index=0&id=802931b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-802931b0"]])

export default __exports__